const ITEMS = [
  "10-Minute Ignition",
  "20-Minute Builder",
  "30-Minute Burn",
  "40-Minute Grind",
  "50-Minute Full Send",
  "Coach-Grade Programming",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative py-5 bg-volt text-white overflow-hidden border-y border-volt/40"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-display font-extrabold uppercase text-xl sm:text-2xl tracking-wider flex items-center"
              >
                <span className="px-6">{item}</span>
                <span className="text-white/50 text-base">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
